import { render, staticRenderFns } from "./flypay_M2.vue?vue&type=template&id=58fb4ef0&scoped=true&"
import script from "./flypay_M2.vue?vue&type=script&lang=js&"
export * from "./flypay_M2.vue?vue&type=script&lang=js&"
import style0 from "./flypay_M2.vue?vue&type=style&index=0&id=58fb4ef0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb4ef0",
  null
  
)

export default component.exports